import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Portfolio() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Work' },
    { id: 'art', name: 'Art & Paintings' },
    { id: 'design', name: 'Graphic Design' },
    { id: 'education', name: 'Educational' },
  ];

  const portfolioItems = [
    {
      id: 1,
      category: 'art',
      title: 'Portrait Commission',
      description: 'Hyperrealistic pencil portrait',
      image: 'https://public.readdy.ai/ai/img_res/89fc0f21f0a93f858215a5c08dd74854.jpg',
    },
    {
      id: 2,
      category: 'art',
      title: 'Canvas Painting',
      description: 'Vibrant acrylic on canvas',
      image: 'https://readdy.ai/api/search-image?query=vibrant%20colorful%20acrylic%20painting%20on%20canvas%20bold%20brushstrokes%20modern%20contemporary%20art%20rich%20textures%20warm%20colors%20professional%20fine%20art%20clean%20simple%20background&width=600&height=800&seq=portfolio-art-2&orientation=portrait',
    },
    {
      id: 3,
      category: 'art',
      title: 'Wall Mural Project',
      description: 'Large-scale office mural',
      image: 'https://readdy.ai/api/search-image?query=modern%20colorful%20wall%20mural%20in%20office%20interior%20abstract%20geometric%20patterns%20professional%20design%20vibrant%20colors%20contemporary%20art%20on%20white%20wall%20clean%20simple%20background&width=800&height=600&seq=portfolio-art-3&orientation=landscape',
    },
    {
      id: 4,
      category: 'design',
      title: 'Event Poster',
      description: 'Professional event promotion',
      image: 'https://readdy.ai/api/search-image?query=modern%20professional%20event%20poster%20design%20bold%20typography%20vibrant%20colors%20elegant%20layout%20contemporary%20graphic%20design%20promotional%20material%20clean%20simple%20background&width=600&height=800&seq=portfolio-design-1&orientation=portrait',
    },
    {
      id: 5,
      category: 'design',
      title: 'Brand Identity',
      description: 'Complete brand package',
      image: 'https://readdy.ai/api/search-image?query=professional%20brand%20identity%20design%20package%20with%20logo%20business%20cards%20modern%20corporate%20style%20clean%20layout%20elegant%20typography%20cohesive%20system%20clean%20simple%20background&width=800&height=600&seq=portfolio-design-2&orientation=landscape',
    },
    {
      id: 6,
      category: 'design',
      title: 'Social Media Campaign',
      description: 'Instagram content series',
      image: 'https://readdy.ai/api/search-image?query=modern%20social%20media%20post%20design%20for%20instagram%20vibrant%20colors%20trendy%20layout%20engaging%20visual%20content%20contemporary%20graphic%20design%20clean%20simple%20background&width=800&height=800&seq=portfolio-design-3&orientation=squarish',
    },
    {
      id: 7,
      category: 'art',
      title: 'Digital Illustration',
      description: 'Character design artwork',
      image: 'https://readdy.ai/api/search-image?query=creative%20character%20design%20digital%20illustration%20original%20concept%20art%20colorful%20modern%20style%20professional%20digital%20painting%20unique%20character%20clean%20simple%20background&width=600&height=800&seq=portfolio-art-4&orientation=portrait',
    },
    {
      id: 8,
      category: 'design',
      title: 'Business Flyer',
      description: 'Corporate marketing material',
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20flyer%20design%20corporate%20style%20clean%20layout%20modern%20typography%20elegant%20color%20scheme%20marketing%20material%20contemporary%20design%20clean%20simple%20background&width=600&height=800&seq=portfolio-design-4&orientation=portrait',
    },
    {
      id: 9,
      category: 'education',
      title: 'Lesson Notes Package',
      description: 'Cultural and Creative Arts materials',
      image: 'https://readdy.ai/api/search-image?query=professional%20educational%20lesson%20notes%20document%20layout%20clean%20organized%20design%20teaching%20materials%20curriculum%20content%20academic%20style%20professional%20formatting%20clean%20simple%20background&width=800&height=600&seq=portfolio-edu-1&orientation=landscape',
    },
    {
      id: 10,
      category: 'art',
      title: 'Family Portrait',
      description: 'Custom family commission',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20pencil%20drawing%20portrait%20of%20african%20family%20realistic%20sketch%20warm%20expression%20professional%20artwork%20on%20white%20paper%20clean%20simple%20background&width=600&height=800&seq=portfolio-art-5&orientation=portrait',
    },
    {
      id: 11,
      category: 'design',
      title: 'Anniversary Graphics',
      description: 'Elegant celebration design',
      image: 'https://readdy.ai/api/search-image?query=elegant%20anniversary%20celebration%20graphic%20design%20sophisticated%20layout%20gold%20accents%20luxury%20style%20professional%20design%20beautiful%20typography%20clean%20simple%20background&width=800&height=800&seq=portfolio-design-5&orientation=squarish',
    },
    {
      id: 12,
      category: 'education',
      title: 'Examination Papers',
      description: 'Test questions and marking scheme',
      image: 'https://readdy.ai/api/search-image?query=professional%20examination%20test%20paper%20document%20layout%20clean%20organized%20format%20educational%20assessment%20materials%20academic%20style%20professional%20design%20clean%20simple%20background&width=800&height=600&seq=portfolio-edu-2&orientation=landscape',
    },
  ];

  const filteredItems = selectedCategory === 'all' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-teal-500 to-blue-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Our Portfolio</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            A showcase of our creative excellence across art, design, and education
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 bg-white sticky top-20 z-40 shadow-sm">
        <div className="container mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map(category => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`whitespace-nowrap px-6 py-3 rounded-full font-semibold transition-all cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-teal-500 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Portfolio Grid */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredItems.map(item => (
              <div key={item.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all group">
                <div className="overflow-hidden">
                  <img 
                    src={item.image}
                    alt={item.title}
                    className="w-full h-96 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold text-teal-500 mb-2">200+</div>
              <p className="text-gray-600 text-lg">Artworks Created</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-purple-500 mb-2">150+</div>
              <p className="text-gray-600 text-lg">Design Projects</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-blue-500 mb-2">100+</div>
              <p className="text-gray-600 text-lg">Happy Clients</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-red-500 mb-2">50+</div>
              <p className="text-gray-600 text-lg">Schools Served</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-purple-500 to-pink-600">
        <div className="container mx-auto px-6 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Let's Create Your Next Project</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Ready to bring your vision to life? Contact us today to discuss your project
          </p>
          <a 
            href="/contact" 
            className="whitespace-nowrap inline-block bg-white hover:bg-gray-100 text-purple-600 px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer shadow-lg"
          >
            Start Your Project
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}